import ResumenCuentaCobrar from "./ResumenCuentaCobrar";

export default ResumenCuentaCobrar;
